let reload_calendar = (actionData) => {
    window.Calendars = window.Calendars || {};
    if (window.Calendars.hasOwnProperty(actionData.calendarId)) {
        window.Calendars[actionData.calendarId].refetchEvents();
    }
};
export default reload_calendar;